"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_INPUT = exports.EXCLUDED_VIRTUAL_DEVICES = exports.AUDIO_OUTPUT = exports.AUDIO_INPUT = void 0;
var AUDIO_INPUT = exports.AUDIO_INPUT = 'audioInput';
var AUDIO_OUTPUT = exports.AUDIO_OUTPUT = 'audioOutput';
var VIDEO_INPUT = exports.VIDEO_INPUT = 'videoInput';
var EXCLUDED_VIRTUAL_DEVICES = exports.EXCLUDED_VIRTUAL_DEVICES = new Set(['ZoomAudioDevice (Virtual)', 'Microsoft Teams Audio Device (Virtual)']);